package app.nestbridge.feature.invitations.presentation

import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(ShowInvitationQRCodePresenter::class)
public class ShowInvitationQRCodePresenterFactory(
  private val factory:
      (screen: ShowInvitationQRCodeScreen, navigator: Navigator) -> ShowInvitationQRCodePresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is ShowInvitationQRCodeScreen -> factory(screen, navigator)
    else -> null
  }
}
